import { Injectable, signal, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { FooterData, IFooterData } from './models/footer-data';

@Injectable()
export class FooterService {

    footerData$$ = signal<IFooterData | null>(null);
    template_buttonLeft$$ = signal<TemplateRef<any> | null>(null);
    template_contentButtons$$ = signal<TemplateRef<any> | null>(null);
    template_contentBlock$$ = signal<TemplateRef<any> | null>(null);
    template_buttonRight$$ = signal<TemplateRef<any> | null>(null);

    // private __footerData: IFooterData = new FooterData();
    // private __footerData$ = new BehaviorSubject<IFooterData>(new FooterData());
    // footerData$ = this._footerData$.asObservable();


    private _template_buttonLeft$ = new BehaviorSubject<TemplateRef<any> | null>(null);
    template_buttonLeft$ = this._template_buttonLeft$.asObservable();
    // set Template_buttonLeft(value: TemplateRef<any>) {
    //     if (value !== undefined) {
    //         this._template_buttonLeft$.next(value);
    //     }
    // }

    private __template_contentBlock$ = new BehaviorSubject<TemplateRef<any> | null>(null);
    template_contentBlock$ = this.__template_contentBlock$.asObservable();
    // set Template_contentBlock(value: TemplateRef<any>) {
    //     if (value !== undefined) {
    //         this._template_contentBlock$.next(value);
    //     }
    // }

    private __template_buttonRight$ = new BehaviorSubject<TemplateRef<any> | null>(null);
    template_buttonRight$ = this.__template_buttonRight$.asObservable();
    // set Template_buttonRight(value: TemplateRef<any>) {
    //     if (value !== undefined) {
    //         this._template_buttonRight$.next(value);
    //     }
    // }

    footerData_set(footerData: Partial<IFooterData>, reset = false): void{
        const currValue = (reset ? null : this.footerData$$()) ?? new FooterData();
        const _footerData = {...currValue, ...footerData};

        this.footerData$$.set(_footerData);
    }

    info_set(info: string | null): void {
        if (info == null) {return;}

        this.footerData_set({info: info});
    }

    infoTooltip_set(infoTooltip: string | null): void {
        if (infoTooltip == null) {return;}

        this.footerData_set({infoTooltip: infoTooltip});
    }

    template_buttonLeft_set(templateRef: TemplateRef<any> | undefined) {
        if (templateRef === undefined) {return;}
        const currValue = this.template_buttonLeft$$();

        if (currValue == null) {
            this.template_buttonLeft$$.set(templateRef);
        }
    }
    
    contentBlock_template_set(templateRef: TemplateRef<any> | undefined) {
        if (templateRef === undefined) {return;}

        this.template_contentBlock$$.set(templateRef);
    }
    
    template_contentButtons_set(templateRef: TemplateRef<any>) {
        if (templateRef === undefined) {return;}

        this.template_contentButtons$$.set(templateRef);
    }
    
    template_buttonRight_set(templateRef: TemplateRef<any>) {
        if (templateRef === undefined) {return;}

        this.template_buttonRight$$.set(templateRef);
    }
}
